import { KeyValueItem, State } from "./types";
import { produce } from "immer";
import Item from "./Item";
import validateItem from "./validateItem";

export default function ItemList({
  paginatedItems,
  state,
  onChange,
}: {
  paginatedItems: KeyValueItem[][];
  state: State;
  onChange: (updatedState: State) => void;
}) {
  function updateRow(id: string, fieldName: string, fieldValue: string) {
    const updatedState = produce(state, draft => {
      const index = draft.items.findIndex(item => item.id === id);
      // update item field
      draft.items[index][fieldName] = fieldValue;

      const error = validateItem(state, draft.items[index]);

      if (draft.errors[id]) delete draft.errors[id];
      if (error) draft.errors[id] = error;
    });

    onChange(updatedState);
  }

  function touchField(id: string, fieldName: "key" | "value") {
    const updatedState = produce(state, draft => {
      if (!draft.touched[id]) draft.touched[id] = {};
      draft.touched[id][fieldName] = true;
    });

    onChange(updatedState);
  }

  function removeRow(id: string) {
    const updatedState = produce(state, draft => {
      const index = draft.items.findIndex(item => item.id === id);
      // remove from items
      draft.items.splice(index, 1);

      // remove from errors and touched
      delete draft.errors[id];
      delete draft.touched[id];
    });

    onChange(updatedState);
  }

  return (
    <>
      {paginatedItems[state.page - 1].map((item, index) => {
        const errors = state.errors[item.id] || {};
        const touched = state.touched[item.id] || {};

        return (
          <Item
            key={item.id}
            item={item}
            index={index}
            onChange={(fieldName, fieldValue) =>
              updateRow(item.id, fieldName, fieldValue)
            }
            onBlur={fieldName => touchField(item.id, fieldName)}
            onRemove={() => removeRow(item.id)}
            error={errors}
            touched={touched}
            canDelete={state.items.length !== 1}
          />
        );
      })}
    </>
  );
}
